import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'

const adsTypeResolver: FieldResolver = (metadata: Metadata) =>
  ({ adsType: metadata.getAdsType() } as StreamData)

export default adsTypeResolver
